import React, { useEffect, useState } from 'react';

// The two fields that name a class, shared by the Classes page and the
// setup wizard: a level picked from the school-wide standard list (Grade 1
// to Grade 7, Form 1 to Form 6 -- served by the backend's class_levels.py)
// and an optional identifier of the school's own choosing.
const MAX_IDENTIFIER_LENGTH = 10;

function ClassLevelFields({ token, name, stream, onChange }) {
  const [levels, setLevels] = useState([]);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/v1/classes/levels', { headers: { Authorization: `Bearer ${token}` } })
      .then((response) => (response.ok ? response.json() : []))
      .then((data) => { if (!cancelled) setLevels(Array.isArray(data) ? data : []); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [token]);

  // A class created before the standard list keeps its old name until
  // someone picks a level for it.
  const options = name && !levels.includes(name) ? [name, ...levels] : levels;
  const preview = name ? [name, stream.trim()].filter(Boolean).join(' ') : '';

  return (
    <>
      <div className="form-row">
        <div className="form-group">
          <label>Grade / Form *</label>
          <select value={name} onChange={(e) => onChange({ name: e.target.value })} required>
            <option value="">Select a level</option>
            {options.map((level) => <option key={level} value={level}>{level}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>Class identifier</label>
          <input
            type="text"
            value={stream}
            maxLength={MAX_IDENTIFIER_LENGTH}
            onChange={(e) => onChange({ stream: e.target.value })}
            placeholder="e.g., B or Blue"
          />
        </div>
      </div>
      <p style={{ color: 'var(--color-text-secondary)', fontSize: '0.8rem', margin: '0 0 0.75rem' }}>
        Leave the identifier empty if there is only one class at this level.
        {preview && <> This class will be called <strong>{preview}</strong>.</>}
      </p>
    </>
  );
}

export default ClassLevelFields;
